import {Component, computed, input, InputSignal, Signal} from '@angular/core';
import {Priority} from '@app/layout/rules/template-editor/api/template';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {TicketsService} from '@app/shared/services/api/tickets/tickets.service';

@Component({
  selector: 'app-priority-badge',
  templateUrl: './priority-badge.component.html',
  styleUrl: './priority-badge.component.scss',
  standalone: false
})
export class PriorityBadgeComponent {
  priority: InputSignal<Priority> = input(null);
  rounded: InputSignal<boolean> = input(false);
  priorityText: Signal<I18nMessage> = computed(() => ({messageKey: this.priority()?.name ?? 'None'}));
  priorityBadgeClass: Signal<string> = computed(() =>
    this.ticketsService.getBadgeColorForPriority(this.priority()?.priority_id ?? null)
    + (this.rounded() ? ' rounded-pill' : '')
  );

  constructor(private ticketsService: TicketsService) {}
}
